import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useOrganization } from '@/components/views/Resolution886/components/Form/_hooks';
import type { FormItemProps } from '@/components/views/Resolution886/types';

interface OrganizationFormItemProps extends FormItemProps {
	fieldName?: string | string[];
}

export function OrganizationFormItem({
	required = true,
	labelCol,
	fieldName,
	disabled = false
}: Readonly<OrganizationFormItemProps>): JSX.Element {
	const { isFetching, isLoading, getOrganizationOptions } = useOrganization();

	return (
		<FormItem
			label="Company"
			name={fieldName}
			required={required}
			labelCol={labelCol}
			requiredMessage="Please select a company"
		>
			<Select
				showSearch
				loading={isFetching}
				options={getOrganizationOptions()}
				disabled={isLoading || disabled}
				placeholder="Select a company"
			/>
		</FormItem>
	);
}
